import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: '',
    component: () => import('../views/layouts.vue'),
    children: [
      {
        path: '/',
        name: 'index',
        component: () => import(/* webpackChunkName: "about" */ '../views/index.vue')
      },
      {
        path: '/retail',
        name: 'retail',
        component: () => import(/* webpackChunkName: "about" */ '../views/retail.vue')
      },
      {
        path: '/wholesale',
        name: 'wholesale',
        component: () => import(/* webpackChunkName: "about" */ '../views/wholesale.vue')
      },
      {
        path: '/restaurant',
        name: 'restaurant',
        component: () => import(/* webpackChunkName: "about" */ '../views/restaurant.vue')
      },
      {
        path: '/act',
        name: 'act',
        component: () => import(/* webpackChunkName: "about" */ '../views/appDownload.vue')
      },
      {
        path: '/aboutUs',
        name: 'aboutUs',
        component: () => import(/* webpackChunkName: "about" */ '../views/aboutUs.vue')
      },
      {
        path: "/AgreementPrivacy",
        name: 'AgreementPrivacy',
        component: () => import(/* webpackChunkName: "about" */ '../views/AgreementPrivacy.vue')
      },
      {
        path: "/AgreementUser",
        name: 'AgreementUser',
        component: () => import(/* webpackChunkName: "about" */ '../views/AgreementUser.vue')
      }
    ]
  },
]

const router = new VueRouter({
  routes
})

export default router
